import { Button, FormControlLabel, Paper, Switch } from "@mui/material";
import { color } from "../../../../theme/color";
import { ComponentState, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getClientDiagnosis, saveClientDiagnosis } from "../../../../redux/actions";
import { DiagnosisModel } from "../../../../dataModel/clientModels";
import moment from "moment";
import SkeletonTypography from "../../../../components/SkeletonTypography";

export const Diagnosis = () => {
  const dispatch = useDispatch()
  const [showPastDx, setShowPastDx] = useState(false)
  const [loading, setLoading] = useState(false)
  const [isListFetched, setListFetched] = useState(false)
  const state: ComponentState = useSelector(states => {
    return states;
  });
  const { diagnosisList } = state['DiagnosisReducer'];

  useEffect(()=>{
    if(diagnosisList){
      setLoading(false)
    }
  },[diagnosisList])

  useEffect(() => {
    if (!isListFetched) {
      setLoading(true)
      dispatch(getClientDiagnosis(!showPastDx))
      setListFetched(true)
    }
  }, [isListFetched])

  useEffect(() => {
    if (isListFetched) {
      dispatch(getClientDiagnosis(!showPastDx))
    }
  }, [showPastDx])

  return (
    <>

<div className="infoWrapper diagonisWrapper">
      <div className="tab-pane care-plan-head" role="tabpanel">
        <h1 style={{  fontSize:"22px", fontWeight:"600" }} >
          <div color={color.palette.black}>
          </div>
          Diagnosis
        </h1>
        <FormControlLabel control={
          <Switch
            checked={showPastDx}
            onChange={(event) => {
              setShowPastDx(!showPastDx)
              setLoading(true)
              dispatch(saveClientDiagnosis())
             
            }} />} label="Show Past Diagnosis" />
      { loading ?
      <SkeletonTypography /> 
      : (diagnosisList.length<1)?
      <div>No Diagnosis in selected category</div>
      :<Paper>
        {  <table className="table">
            <thead>
              <tr>
                <th>Dx Code</th>
                <th>Diagnosis</th>
                <th>Diagnosis Date</th>

              </tr>
            </thead>
            <tbody style={{ padding: "auto 10px auto 10px" }}>
              {
                diagnosisList?.map((item: DiagnosisModel) => {
                  return (
                    <tr >
                      <td>{item.icd10}</td>
                      <td>{item.diagnoseName}</td>
                      <td>{moment(item.dateDiagnose).format('MM/DD/YYYY')}</td>
                    </tr>
                  )
                })
              }
            </tbody>
          </table>
          }

        </Paper>}
      </div>

</div>
    </>)
}

